import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { LocalStorageService } from './local-storage.service';

@Injectable()
export class RedirectGuard implements CanActivate {

  constructor(
  	private _localStorageService:LocalStorageService,
  	private _router: Router) {

  }	

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
  	let authenticated = this._localStorageService.hasKey('token');
  	if (authenticated) {
  		this._router.navigate(['']);
  		return false;
  	}
    return true;
  }
}


// WEBPACK FOOTER //
// ./src/app/vqutils/redirect.guard.ts